<template>
  <el-container class="form-body">
    <el-main class='form-login-body'>
      <el-form key="d" :model="ruleForm" :rules="rules" ref="ruleForm" @keyup.enter.native="loginClick">
        <!--账号框-->
        <el-form-item prop="phone" class="login-meta">
          <div class="wrap-input">
            <el-input :placeholder="accountPlaceholder" v-model="ruleForm.phone" @input="cleanPassword">
              <div slot="prepend">
                <div class="input-icon-up">
                  <img src="../../../../assets/user.png" alt="" />
                </div>
              </div>
            </el-input>
          </div>
        </el-form-item>
        <!--Web密码框-->
        <el-form-item v-if='isCollapse' prop="password" class="login-meta">
          <div class="wrap-input">
            <el-input show-password placeholder="请输入密码" maxlength="20"
                      v-model="ruleForm.password">
              <div slot="prepend">
                <div class="input-icon-up">
                  <img src="../../../../assets/pass.png" alt="" />
                </div>
              </div>
            </el-input>
          </div>
        </el-form-item>
        <!--App密码框-->
        <el-form-item v-else prop="password" class="login-meta">
          <div class="wrap-input">
            <el-input v-model="ruleForm.password" class="input-icon input-icon-two" size="large" :type="passwordFlag" placeholder="请输入登录密码">
              <template slot="prepend">
                <div class="input-icon-up">
                  <img src="../../../../assets/pass.png" alt="" />
                </div>
              </template>
              <template slot="append">
                <div class="input-icon-up" @click="switchPassShow">
                  <img v-if="passwordFlag !== 'password'" src="../../../../assets/look.png" alt="" />
                  <img v-else src="../../../../assets/hidden.png" alt="" />
                </div>
              </template>
            </el-input>
          </div>
        </el-form-item>
        <!--App登录按钮-->
        <el-form-item v-if='!isCollapse' class="form-bottom">
          <div class="bottom-pwd">
            <el-checkbox class="remember-pass" v-model="isChecked" @change="checkPasswordChange">记住密码</el-checkbox>
            <div class="pass-text" @click="gotoForgetPwd()">忘记密码</div>
          </div>
          <el-button size="large" type="primary" class="login-button" @click.stop.prevent="loginClick">
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </el-main>
    <!--Web登录按钮-->
    <el-footer v-if='isCollapse' class='form-login-footer' style="height: 78px !important;">
      <div class="bottom-pwd">
        <el-checkbox class="remember-pass" v-model="isChecked" @change="checkPasswordChange">记住密码</el-checkbox>
        <div class="pass-text" @click="gotoForgetPwd()">忘记密码</div>
      </div>
      <el-button type="primary" @click="loginClick" class="login-btn">
        登录
      </el-button>
    </el-footer>
  </el-container>
</template>

<script>
import 'vant/lib/index.css';
import { decrypt, encrypt, getStorage, removeStorage, setStorage } from '@/libs/util'

export default {
  name: 'login-by-pwd',
  props: {
    isCollapse: {
      type: Boolean,
      value: false,
    },
    accountPlaceholder: {
      type: String,
      value: '',
    },
  },
  data() {
    const validateAccount = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.accountPlaceholder));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    };
    return {
      passwordFlag: 'password',
      isChecked: false,
      ruleForm: {
        phone: '',
        password: '',
      },
      rules: {
        phone: [
          {validator: validateAccount, trigger: 'blur'},
        ],
        password: [
          {validator: validatePassword, trigger: 'blur'}
        ]
      },
    }
  },
  mounted() {
    let account = getStorage('login_account');
    let pass = getStorage('login_password');
    console.log('account = ', account);
    console.log('pass = ', pass);
    if (account != null && pass != null) {
      this.ruleForm.password = decrypt(pass);
      this.ruleForm.phone = decrypt(account);
      this.isChecked = true;
    }
  },
  methods: {
    checkPasswordChange (value) {
      if (value) {
        setStorage('login_password', encrypt(this.ruleForm.password))
        setStorage('login_account', encrypt(this.ruleForm.phone))
      } else {
        removeStorage('login_password')
        removeStorage('login_account')
      }
    },
    cleanPassword () {
      removeStorage('login_password');
      removeStorage('login_account');
      this.ruleForm.password = '';
    },
    switchPassShow () {
      this.passwordFlag = this.passwordFlag === 'password' ? 'text' : 'password'
    },
    gotoForgetPwd () {
      console.log('gotoForgetPwd 1');
      this.$emit('gotoForgetPwd');
    },
    async loginClick() {
      this.$refs['ruleForm'].validate(async (valid) => {
        if (valid) {
          await this.didLogin();
        } else {
          return false;
        }
      });
    },
    async didLogin() {
      this.checkPasswordChange(this.isChecked);
      let param = {
        "agree": "1",//
        //密码ζ验证码
        "loginCode": this.ruleForm.password,
        "loginName": this.ruleForm.phone,
        "loginType": '2',
      }
      this.$emit('login', param);
    },
  }
}
</script>